import moment from "moment"
//import 'moment/locale/lo'
//moment.locale('lo');

export default moment
